import { POST_SAVED_ROUTE_NAME } from "@/libs/route-name";

export const AllPostSaved = () => {
  return {
    name: POST_SAVED_ROUTE_NAME.ALL_POST_SAVED,
    path: "all-post-saved",
    component: () => import("@/pages/post-saved/index.vue")
  };
};
